import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { CheckConsentProvider } from 'src/context/consent/check-consent-provider';
import { DashBoardProvider } from 'src/context/dashboard/provider';
import { RealTimeProvider } from 'src/context/realtimeUpdates/provider';

// ----------------------------------------------------------------------
// ProductLibrary
const ProductLibrary = lazy(() => import('src/pages/dashboard/productLibrary'));
// MetadataTranslator
const NewMetadataTranslator = lazy(() => import('src/pages/dashboard/MetadataTranslator'));

// PromptBuilder
const PromptBuilder = lazy(() => import('src/pages/dashboard/promptBuilder'));
// Agent Templates
const AgentTemplates = lazy(() => import('src/pages/dashboard/agentTemplates'));
// Jobs
const Logs = lazy(() => import('src/pages/dashboard/jobs'));
const MTJobs = lazy(() => import('src/pages/dashboard/MTjobs'));
const MTJobsDetails = lazy(() => import('src/pages/dashboard/MTJobDetails'));
// Glossary
const GlossaryList = lazy(() => import('src/pages/dashboard/glossaryList'));

const GlossaryListItem = lazy(() => import('src/pages/dashboard/glossaryListItem'));

const CompanyInformation = lazy(() => import('src/pages/dashboard/companyInformation/organization'));
// USER
const UserListPage = lazy(() => import('src/pages/dashboard/user/user'));
const SecurityPage = lazy(() => import('src/pages/dashboard/Security'));
const ApprovalPage = lazy(() => import('src/pages/dashboard/approval'));
const AccountPage = lazy(() => import('src/pages/dashboard/user/account'));

const TranslationEnginePage = lazy(() => import('src/pages/dashboard/translationEngine'));
const AIEnginesPage = lazy(() => import('src/pages/dashboard/aiEngines'));
const AICommandCenterPage = lazy(() => import('src/pages/dashboard/aiCommandCenter'));

// Credentials
const Credentials = lazy(() => import('src/pages/setup/credentials'));

// ----------------------------------------------------------------------
const queryParameters = new URLSearchParams(window.location.search);

const inviteKey = queryParameters.get('inviteKey');

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard inviteKey={inviteKey}>
        <CheckConsentProvider>
          <DashBoardProvider>
            <RealTimeProvider>
              <DashboardLayout>
                <Suspense fallback={null}>
                  <Outlet />
                </Suspense>
              </DashboardLayout>
            </RealTimeProvider>
          </DashBoardProvider>
        </CheckConsentProvider>
      </AuthGuard>
    ),
    children: [
      { element: <NewMetadataTranslator />, index: true },
      // { path: 'new', element: <NewMetadataTranslator /> },
      { path: 'product-library', element: <ProductLibrary /> },
      { path: 'Logs', element: <Logs /> },
      { path: 'MTJobs', element: <MTJobs /> },
      { path: 'MTJobDetails', element: <MTJobsDetails /> },
      { path: 'PromptBuilder', element: <PromptBuilder /> },
      { path: 'agent-templates', element: <AgentTemplates /> },
      {
        path: 'glossary',
        children: [
          { path: '', element: <GlossaryList /> },
          { path: ':id', element: <GlossaryListItem /> },
        ],
      },
      // { path: 'glossary/*', element: <GlossaryListItem /> },
      { path: 'credentials', element: <Credentials /> },
      { path: 'companyInformation', element: <CompanyInformation /> },
      { path: 'security', element: <SecurityPage /> },
      { path: 'approval', element: <ApprovalPage /> },
      { path: 'translationEngine', element: <TranslationEnginePage /> },
      { path: 'aiEngines', element: <AIEnginesPage /> },
      { path: 'aiCommandCenter', element: <AICommandCenterPage /> }, // Overview
      { path: 'aiCommandCenter/useCase/:useCaseId', element: <AICommandCenterPage /> }, // Deep Dive
      { path: 'aiCommandCenter/executionLog/:useCaseId', element: <AICommandCenterPage /> }, // Execution Log
      { path: 'aiCommandCenter/chatSessions/:useCaseId', element: <AICommandCenterPage /> }, // Chat Sessions
      { path: 'user', element: <UserListPage /> },
      { path: 'user/account', element: <AccountPage /> },
    ],
  },
];
